module.exports = __webpack_public_path__ + "img/period_overlay.2a82701a.png";